import { clsx } from 'clsx';
import type { SelectHTMLAttributes } from 'react';

export function Select({ className, children, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={clsx(
        'h-10 w-full rounded-xl border border-border bg-white px-3 text-base text-brown',
        'focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
}
